import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import PageBanner from "components/common/PageBanner";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const courses = {
  "pho-thong-tieu-chuan": {
    backgroundColor: "tertiary.yellow.opaque",
    bullet: "/images/pho-thong-tieu-chuan-bullet.png",
    image: "/images/pho-thong-tieu-chuan.png",
    courseName: "Khoá Phổ thông Tiêu chuẩn",
    courseDescription:
      "Khoá học Phổ thông Tiêu chuẩn tại The English Tree được thiết kế bám sát chương trình Tiếng Anh trên trường, giúp học sinh nắm chắc kiến thức – nâng cao điểm số – học đúng trọng tâm.",
    sellingPoints: [
      "Thời lượng học: 2 buổi/tuần – mỗi buổi 90 phút",
      "Giảng dạy: 100% số buổi có giáo viên nước ngoài",
      "Nội dung: Ngữ pháp, từ vựng, kỹ năng đọc – viết theo chương trình chính khoá",
      "Mục tiêu: Hiểu bài trên lớp, làm bài kiểm tra – thi học kỳ hiệu quả",
      "Cam kết: Điểm trung bình môn Tiếng Anh không dưới 8",
      "Trực tiếp giáo viên chủ nhiệm lớp tương tác định kỳ với ba mẹ ",
    ],
    expectedResults: [
      "Khoá học phù hợp với học sinh cần củng cố nền tảng, theo kịp chương trình trên lớp và cải thiện kết quả học tập một cách bền vững.",
    ],
  },
  "pho-thong-vip": {
    backgroundColor: "secondary.opaque",
    bullet: "/images/pho-thong-vip-bullet.png",
    image: "/images/pho-thong-vip.png",
    courseName: "Khoá Phổ thông VIP",
    courseDescription:
      "Khoá học Phổ thông Tiêu chuẩn VIP tại The English Tree là chương trình học toàn diện, kết hợp học chính khoá – kèm cặp cá nhân – nâng cao giao tiếp, dành cho học sinh cần kết quả học tập vững chắc và sự theo sát sát sao.",
    sellingPoints: [
      "Thời lượng học: 2 buổi/tuần – mỗi buổi 90 phút",
      "Giảng dạy: 100% số buổi có giáo viên nước ngoài",
      "Nội dung chính khoá: Bám sát chương trình Tiếng Anh trên trường, hệ thống hoá ngữ pháp – từ vựng – kỹ năng làm bài",
      "Cam kết học tập: Điểm trung bình môn Tiếng Anh không dưới 8",
      "Trực tiếp giáo viên chủ nhiệm lớp tương tác định kỳ với ba mẹ",
    ],
    expectedResults: [
      "Khoá học phù hợp với học sinh cần được theo sát từng bước, vừa đảm bảo điểm số trên trường, vừa phát triển khả năng giao tiếp tiếng Anh tự tin và thực tế.",
    ],
    vip: {
      backgroundColor: "secondary.main",
      title: "Quyền lợi VIP nổi bật",
      content: (
        <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <li>
            Huấn luyện viên học tập cá nhân (Online): 4 buổi/tháng, rà soát kiến
            thức trên trường, chữa bài, củng cố điểm yếu kịp thời
          </li>
          <li>
            Khoá học online 1–1 với giáo viên nước ngoài: Tập trung nâng cao kỹ
            năng giao tiếp, phản xạ và phát âm chuẩn
          </li>
        </ul>
      ),
    },
  },
  "quoc-te-tieu-chuan": {
    backgroundColor: "primary.opaque",
    bullet: "/images/quoc-te-tieu-chuan-bullet.png",
    image: "/images/quoc-te-tieu-chuan.png",
    courseName: "Khoá Quốc tế Tiêu chuẩn",
    courseDescription:
      "Khoá học Quốc tế Tiêu chuẩn tại The English Tree được xây dựng theo chương trình chuẩn Cambridge, giúp học viên phát triển đồng thời năng lực tiếng Anh học thuật – kỹ năng sử dụng ngôn ngữ thực tế, đáp ứng yêu cầu học tập trong nước và quốc tế.",
    sellingPoints: [
      "Thời lượng học: 2 buổi/tuần – mỗi buổi 105 phút",
      "Chương trình học: Chuẩn Cambridge (Starters – Movers – Flyers / KET – PET – FCE)",
      "Giảng dạy: 100% số buổi có giáo viên nước ngoài",
      "Trực tiếp giáo viên chủ nhiệm lớp tương tác định kỳ với ba mẹ",
    ],
    expectedResults: (
      <div>
        <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <li>Cam kết đạt chứng chỉ Cambridge theo đúng lộ trình học</li>
          <li>
            Cam kết điểm trung bình môn Tiếng Anh trên trường không dưới 8
          </li>
          <li>Trực tiếp giáo viên chủ nhiệm lớp tương tác định kỳ với ba mẹ</li>
        </ul>
        <p style={{ paddingLeft: "24px" }}>
          Khoá học phù hợp với học viên mong muốn học chuẩn quốc tế, xây nền
          tảng vững chắc cho các kỳ thi Cambridge và sử dụng tiếng Anh tự tin –
          chính xác – học thuật.
        </p>
      </div>
    ),
  },
  "quoc-te-vip": {
    backgroundColor: "tertiary.blue.opaque",
    bullet: "/images/quoc-te-vip-bullet.png",
    image: "/images/quoc-te-vip.png",
    courseName: "Khoá Quốc tế VIP",
    courseDescription:
      "Khoá học Quốc tế VIP tại The English Tree là chương trình đào tạo chuyên sâu theo chuẩn Cambridge, kết hợp giảng dạy 100% giáo viên nước ngoài – kèm cặp cá nhân – luyện giao tiếp 1–1, dành cho học viên định hướng học tập quốc tế và kết quả vượt trội.",
    sellingPoints: [
      "Thời lượng học: 2 buổi/tuần – mỗi buổi 105 phút",
      "Chương trình học: Chuẩn Cambridge (Starters – Movers – Flyers / KET – PET – FCE)",
      "Giảng dạy: 100% số buổi có giáo viên nước ngoài",
    ],
    expectedResults: [
      "Cam kết đạt chứng chỉ Cambridge theo lộ trình",
      "Cam kết điểm trung bình môn Tiếng Anh trên trường không dưới 8",
      "Trực tiếp giáo viên chủ nhiệm lớp tương tác định kỳ với ba mẹ",
    ],
    vip: {
      backgroundColor: "tertiary.blue.main",
      title: "Quyền lợi VIP vượt trội",
      content: (
        <div>
          <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <li>
              Huấn luyện viên học tập cá nhân (Online): 4 buổi/tháng, rà soát
              kiến thức trên trường, chữa bài, củng cố và bù lấp lỗ hổng kịp
              thời
            </li>
            <li>
              Khoá học online 1–1 với giáo viên nước ngoài: Tập trung nâng cao
              kỹ năng giao tiếp, phản xạ, phát âm và sự tự tin khi sử dụng tiếng
              Anh
            </li>
          </ul>
          <p style={{ paddingLeft: "24px" }}>
            Khoá học phù hợp với học viên cần được theo sát sát sao, vừa đảm bảo
            chuẩn quốc tế – chứng chỉ Cambridge, vừa duy trì thành tích học tập
            xuất sắc trên trường.
          </p>
        </div>
      ),
    },
  },
  "robotics-ai": {
    backgroundColor: "info.opaque",
    bullet: "/images/robotics-ai-bullet.png",
    image: "/images/robotics-ai.png",
    courseName: "Khoá Robotics & AI",
    courseDescription: (
      <div>
        <p>
          Khoá học Robotics & AI được biên soạn và quản lý chất lượng bởi Tiến
          sĩ Robotechs cùng đội ngũ chuyên gia giàu kinh nghiệm trong lĩnh vực
          công nghệ và trí tuệ nhân tạo.
        </p>
        <p>
          Chương trình được liên tục cập nhật theo xu hướng công nghệ mới nhất,
          đồng thời lồng ghép kiến thức Toán học và Vật lý trong chương trình
          phổ thông, giúp học viên hiểu bản chất – ứng dụng thực tế và phát
          triển tư duy khoa học.
        </p>
      </div>
    ),
    sellingPoints: [
      "Xây dựng nền tảng công nghệ số và tư duy lập trình từ sớm",
      "Kết hợp Robotics – AI – Toán – Vật lý một cách hệ thống",
      "Sĩ số tối đa 6 học viên/lớp, đảm bảo kèm cặp sát sao và hiệu quả học tập",
    ],
    expectedResults: [
      "Khoá học phù hợp với học viên yêu thích công nghệ, sáng tạo và định hướng STEM/STEAM trong tương lai.",
    ],
  },
  "giao-tiep-giao-vien-nuoc-ngoai": {
    backgroundColor: "tertiary.pink.opaque",
    bullet: "/images/giao-tiep-giao-vien-nuoc-ngoai-bullet.png",
    image: "/images/giao-tiep-giao-vien-nuoc-ngoai.png",
    courseName: "Khoá Giao tiếp 1-1 với Giáo viên Nước ngoài",
    courseDescription:
      "Khoá học giao tiếp 1–1 tại The English Tree mang đến trải nghiệm học cá nhân hoá tối đa, giúp học viên rèn luyện phản xạ – phát âm – giao tiếp thực tế một cách hiệu quả và linh hoạt.",
    sellingPoints: [
      "Giáo viên nước ngoài làm việc full-time, đến từ 5 văn phòng tại Philippines, được tuyển chọn và quản lý chất lượng chặt chẽ",
      "Take care 1–1 xuyên suốt buổi học, học viên có nhiều thời gian thực hành, trao đổi và phản xạ trực tiếp với giáo viên",
      "Ghi hình toàn bộ buổi học, dễ dàng xem lại để ôn tập và cải thiện kỹ năng",
      "Thời gian học linh hoạt, học online – không cần di chuyển",
      "Chủ động lựa chọn giáo viên và thay đổi đến khi hài lòng",
      "Tự do lựa chọn giáo trình phù hợp với trình độ và mục tiêu học tập",
      "Không giới hạn thời gian sử dụng: được bảo lưu, chuyển nhượng và thay đổi lịch học linh hoạt trước 2,5 giờ",
      "Đánh giá định kỳ và gửi báo cáo kết quả học tập cho phụ huynh",
    ],
    expectedResults: [
      "Khoá học phù hợp với học viên cần cải thiện giao tiếp nhanh, học theo lịch cá nhân và mong muốn một lộ trình học linh hoạt – hiệu quả – theo sát.",
    ],
  },
  "thuc-chien": {
    backgroundColor: "secondary.opaque",
    bullet: "/images/thuc-chien-bullet.png",
    image: "/images/thuc-chien.png",
    courseName: "Câu lạc bộ Tiếng Anh Thực chiến",
    courseDescription:
      "Câu lạc bộ Tiếng Anh Thực chiến tại The English Tree là môi trường luyện nói năng động, giúp học viên nói được – phản xạ nhanh – dùng tiếng Anh như trong đời sống thật.",
    sellingPoints: [
      "Thời lượng: 2 buổi/tháng – mỗi buổi 90 phút",
      "100% thời gian học với giáo viên nước ngoài",
      "Trọng tâm: Giao tiếp thực tế – nói như người bản xứ trong các tình huống đời thường",
      "Không học ngữ pháp khô khan – học để sử dụng được ngay",
    ],
    expectedResults: (
      <div>
        <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <li>Học qua thực hành và mô phỏng tình huống</li>
          <li>Thực hành đối thoại theo cặp/nhóm liên tục</li>
          <li>
            Mô phỏng các tình huống thật: gọi điện thoại, thuyết trình, trao đổi
            công việc, giao tiếp hằng ngày
          </li>
        </ul>
        <p style={{ paddingLeft: "24px" }}>
          Câu lạc bộ phù hợp với học viên muốn luyện nói thường xuyên, phá bỏ
          tâm lý ngại nói và tăng phản xạ giao tiếp trong môi trường 100% tiếng
          Anh.
        </p>
      </div>
    ),
  },
};

function CourseDescription({ image, courseId, courseDescription }) {
  const navigate = useNavigate();

  return (
    <Stack spacing={4}>
      <Stack direction="row" justifyContent="center">
        <Typography
          className="highlight"
          variant="h3"
          color="info.main"
          align="center"
        >
          Tổng quan khoá học
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        useFlexGap
        flexWrap="wrap"
        spacing={4}
        padding={2}
      >
        <div>
          <img src={image} alt={courseId} loading="lazy" width={350} />
        </div>

        <Stack alignItems="center" width={650} spacing={8}>
          <Typography variant="body1" color="info.main">
            {courseDescription}
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/dang-ki-hoc-thu")}
          >
            ĐĂNG KÍ NGAY
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

function SellingPoints({ backgroundColor, bullet, courseId, sellingPoints }) {
  return (
    <Stack
      spacing={4}
      padding={4}
      sx={{
        backgroundColor,
      }}
    >
      <Stack direction="row" justifyContent="center">
        <Typography variant="h3" color="info.main" align="center">
          Điểm đặc biệt
        </Typography>
      </Stack>

      <Stack alignItems="center">
        <Stack spacing={2} sx={{ maxWidth: 750 }}>
          {sellingPoints.map((sellingPoint) => (
            <Stack
              key={sellingPoint}
              direction="row"
              alignItems="center"
              spacing={2}
            >
              <img src={bullet} alt={`${courseId}-bullet-point`} width={35} />
              <Typography key={sellingPoint} variant="body1" color="info.main">
                {sellingPoint}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}

function ExpectedResults({ image, courseId, expectedResults }) {
  return (
    <Stack spacing={4}>
      <Stack direction="row" justifyContent="center">
        <Typography
          className="highlight"
          variant="h3"
          color="info.main"
          align="center"
        >
          Kết quả đạt được
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        useFlexGap
        flexWrap="wrap"
        spacing={4}
        padding={2}
      >
        <Stack spacing={2} sx={{ maxWidth: 550 }}>
          {Array.isArray(expectedResults) &&
            expectedResults.length > 1 &&
            expectedResults.map((expectedResult, index) => (
              <Stack key={expectedResult} direction="row" spacing={2}>
                <Typography variant="body1" color="info.main">
                  {index + 1}.
                </Typography>
                <Typography variant="body1" color="info.main">
                  {expectedResult}
                </Typography>
              </Stack>
            ))}
          {Array.isArray(expectedResults) && expectedResults.length === 1 && (
            <Typography variant="body1" color="info.main">
              {expectedResults[0]}
            </Typography>
          )}
          {!Array.isArray(expectedResults) && (
            <Typography variant="body1" color="info.main">
              {expectedResults}
            </Typography>
          )}
        </Stack>

        <div>
          <img src={image} alt={courseId} loading="lazy" width={350} />
        </div>
      </Stack>
    </Stack>
  );
}

function VIP({ backgroundColor, title, content, promo }) {
  return (
    <Stack
      spacing={2}
      padding={4}
      alignItems="center"
      sx={{
        backgroundColor,
      }}
    >
      <Stack direction="row" justifyContent="center">
        <Typography variant="h3" color="common.white">
          {title}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        spacing={4}
        justifyContent="center"
        useFlexGap
        flexWrap="wrap"
      >
        <Typography variant="body1" color="common.white" sx={{ maxWidth: 550 }}>
          {content}
        </Typography>

        {promo && (
          <Card
            sx={{
              maxWidth: 550,
              padding: 2,
              backgroundColor: "common.white",
              borderRadius: 2,
            }}
          >
            <CardContent>
              <Typography variant="body1" color="info.main">
                {promo}
              </Typography>
            </CardContent>
          </Card>
        )}
      </Stack>
    </Stack>
  );
}

function CoursePage() {
  const { courseId } = useParams();

  const {
    backgroundColor,
    bullet,
    image,
    courseName,
    courseDescription,
    sellingPoints,
    expectedResults,
    vip,
  } = courses[courseId];

  return (
    <Stack spacing={10}>
      <Helmet>
        <title>{courseName}</title>
        <meta
          name="description"
          content="The English Tree đưa ra các khoá học bám sát theo sự phát triển của bé, với lộ trình đầu ra chuẩn quốc tế."
        />
        <link
          rel="canonical"
          href={`https://englishtree.edu.vn/khoa-hoc/${courseId}`}
        />
      </Helmet>

      <PageBanner
        backgroundImage="/images/pink-banner.png"
        heading={courseName}
        pageName={courseName}
      />

      <CourseDescription
        image={image}
        courseId={courseId}
        courseDescription={courseDescription}
      />

      <SellingPoints
        backgroundColor={backgroundColor}
        bullet={bullet}
        courseId={courseId}
        sellingPoints={sellingPoints}
      />

      <ExpectedResults
        image={image}
        courseId={courseId}
        expectedResults={expectedResults}
      />

      {vip && <VIP {...vip} />}
    </Stack>
  );
}

export default CoursePage;
